import React from 'react';
import AppLayout from '../components/app/AppLayout';
import Settings from '../components/app/Settings';

function SettingsPage() {
  return (
    <AppLayout>
      <Settings />
    </AppLayout>
  );
}

export default SettingsPage;







